import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import Item from "src/components/wizard/Item/Item";
import LabelingOptionsModal from "../../../modals/LabelingOptionsModal";
import useItemLabelsModal from "../../../../hooks/useItemLabelsModal";

const getRackLocationParts = rackLocations => {
  if (!rackLocations?.length) return null;
  const loc = rackLocations[0];
  const mobile = loc?.mobile_warehouse_location?.location_name || loc?.mobileWarehouseLocation?.locationName;
  const warehouse = loc?.warehouse_locations?.[0]?.location_name || loc?.warehouseLocations?.[0]?.locationName;
  if (!mobile && !warehouse) return null;
  return { mobile, warehouse };
};

export default function ShipmentItem({ value, project, selected, onSelect, shipmentId }) {
  const itemLabelsModal = useItemLabelsModal();
  const isOnsiteManifest = project?.settings?.onsite_manifest;

  const handleClick = () => {
    onSelect(value);
  };

  const rackParts = isOnsiteManifest
    ? getRackLocationParts(value.rackLocations || value.asset?.rackLocations)
    : null;

  return (
    <>
      <Item
        key={value.id}
        value={value}
        project={project}
        selected={selected}
        info={
          <Box>
            {value.asset.serialNumber && (
              <Typography mt={0.5} sx={{ color: "error.main" }}>
                Serial #: {value.asset.serialNumber}
              </Typography>
            )}
            {value.quantity === 0 ? (
              <Box mt={0.5} color="red" fontWeight={500} fontSize="1.0rem">
                Expected Quantity: {value.expectedQuantity || 0}
              </Box>
            ) : (
              <Box mt={0.5} fontWeight={500} fontSize="1.0rem">
                Quantity: {value.quantity}
              </Box>
            )}
            {value.quantity * value.asset?.weight > 0 && (
              <Box mt={0.5} fontSize="1.0rem">
                Total Weight: {value.quantity * value.asset.weight}
              </Box>
            )}
            {(value.rackLocations?.length || 0) > 1 && (
              <Box mt={0.5} fontSize="1.0rem">
                Locations: {value.rackLocations.length}
              </Box>
            )}
          </Box>
        }
        actions={
          isOnsiteManifest ? (
            rackParts ? (
              <Box textAlign="center" color="text.secondary" fontSize="0.875rem" lineHeight={1.4}>
                {rackParts.mobile && <Box>{rackParts.mobile}</Box>}
                {rackParts.mobile && rackParts.warehouse && <Box>-</Box>}
                {rackParts.warehouse && <Box>{rackParts.warehouse}</Box>}
              </Box>
            ) : null
          ) : (
            <Box>
              <Button onClick={() => itemLabelsModal.openForShipment(shipmentId, value.id)}>
                <PictureAsPdfOutlinedIcon sx={{ fontSize: 28 }} />
              </Button>
            </Box>
          )
        }
        onClick={handleClick}
      />
      {itemLabelsModal.isOpen && itemLabelsModal.shipmentItemId === value.id && (
        <LabelingOptionsModal
          shipmentId={shipmentId}
          shipmentItemId={value.id}
          project={project}
          onClose={itemLabelsModal.close}
        />
      )}
    </>
  );
}
